import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import Step2Video from './Step2Video.react';
var Step2 = function Step2() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step-2"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step2/Step-2.png",
    className: "ht-step-2__2"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step2/Step-2-RO.png",
    className: "ht-step-2__ro2"
  }), /*#__PURE__*/React.createElement(Step2Video, null), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step2/step2-dump.png",
    className: "ht-step-2__dump"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step2/step2-subhead.png",
    className: "ht-step-2__subheader"
  }));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Step2);